import * as tslib_1 from "tslib";
import { BaseCanActivateService } from '../core/base-can-activate.service';
import { BookingStepsService } from '../core/booking-steps.service';
import { FlowManagerService } from '../core/flow-manager.service';
var CanActivateSummaryOnBookingService = /** @class */ (function (_super) {
    tslib_1.__extends(CanActivateSummaryOnBookingService, _super);
    function CanActivateSummaryOnBookingService(flowManager, steps) {
        var _this = _super.call(this, steps, flowManager.applicationFlowService) || this;
        _this.forceFlowInfoRefresh = true;
        return _this;
    }
    return CanActivateSummaryOnBookingService;
}(BaseCanActivateService));
export { CanActivateSummaryOnBookingService };
